/** Constructor
    container for SelectionSets
 */
var Selection = function() {};

// Returns a string of tab delimited records for all selection-sets with active selections
Selection.prototype.tabDelimit = function() {
  var header, row, out='';
  for (const layer in this) {
    let thisLayer = this[layer];
    // if this layer currently has a selection
    if (typeof(thisLayer) !== 'function' &&
        thisLayer.selection &&  // exclude selectInteraction which now lives in the rwg.selection object
        Object.keys(thisLayer.selection).length) {

      out += layer + '\n';

      header = '';
      for (const label in thisLayer.format) {
        if (thisLayer.format[label][0] !== false) { // exclude fields where label is false (geom columns)
          header += thisLayer.format[label][0] + '\t';
        }
      }
      out += header + '\n';

      for (const record in thisLayer.selection) {
        row = '';
        for (const field in thisLayer.selection[record]) {
          if (field && thisLayer.format[field][0] !== false) { // exclude fields where label is false (geom columns)
            row += thisLayer.selection[record][field] + '\t';
          }
        }
        out += row + '\n';
      }
    }
  }
  return out;
};

// Clears all active selection sets
Selection.prototype.clear = function() {
  for (const key in this) {
    if (typeof this[key].clear === 'function') {
      this[key].clear();
    }
  }
};

Selection.prototype.method = '' // 'point' or 'box'

export {Selection as default};
